import { Component, inject, input, OnInit, signal } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { AssetTimeSeriesService } from '@app/pages/cmms/components/assets/asset-time-series/misc/asset-time-series-service';
import { AssetChartWithSettingsComponent } from '@app/pages/cmms/components/assets/asset-time-series/chart-with-settings/asset-chart-with-settings.component';
import { toSignal } from '@angular/core/rxjs-interop';
import { filter } from 'rxjs';
import { NgxTolgeeModule } from '@tolgee/ngx';

@Component({
	selector: 'asset-charts-list-section',
	templateUrl: './chart-list-root.component.html',
	styleUrls: ['./chart-list-root.component.scss'],
	imports: [
		AssetChartWithSettingsComponent,
		MatIconModule,
		MatMenuModule,
		NgxTolgeeModule,
	],
	providers: [AssetTimeSeriesService],
})
export class ChartListRootComponent implements OnInit {
	private readonly assetTimeSeriesService = inject(AssetTimeSeriesService);

	assetPk = input<string>();
	title = input<string>();

	seriesSections = toSignal(
		this.assetTimeSeriesService.timeSeries$.pipe(filter(series => series != null))
	);
	showNewGraphSettingsComponent = signal(false);

	ngOnInit() {
		this.assetTimeSeriesService.fetchAndStoreTimeSeries(this.assetPk());
	}

	addElementToGraphList() {
		this.showNewGraphSettingsComponent.set(true);
	}

	closeNewGraphComponent() {
		this.showNewGraphSettingsComponent.set(false);
	}
}
